<template>
    <div class="join-our">
        <div class="text row">
            <div class="join-for col">
                <p class="txt-join">Join Our Community</p> <br />
                <p class="txt-for">for a better future</p>
            </div>
            <div class="col">
                <button class="btn-join">Join Now</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: `JoinOur`
    }
</script>

<style>

.join-our {
    margin-bottom: 300px;
}
.join-our .join-for {
  margin-left: 100px;
}
.btn-join {
    color: white;
    border: 1px solid #f74d00;
}
.btn-join:hover {
    background-color: white;
    color: black;
    border: 1px solid black;
}

@media only screen and (max-width: 370px) {
  .join-our .join-for {
      margin-left: 25%;
  }
  .join-our .txt-join {
    font-size: 16px;
    margin-left: 0%;
  }
  .join-our .txt-for {
    margin-top: 0%;
    margin-left: 0%;
  }
  .join-our .btn-join {
    margin-left: 25%;
    margin-bottom: -100%;
  }
  .join-our p {
      margin-bottom: 0%;
  }
}
</style>